export default __webpack_public_path__ + "static/media/vibe.f46e82ca.svg";